import "@hotwired/turbo-rails";
import "chartkick/chart.js";

import * as ActiveStorage from "@rails/activestorage";
import "./controllers";
import "./components/direct_uploads";
import "./components/analytics";
import "./components/posthog";

ActiveStorage.start();

// Global hack for anchors to get anchor "support" from controllers' redirect_to.
// Turbo doesn't support anchors in redirect_to, but we can use a query parameter to achieve the same effect:
// `redirect_to some_path(_anchor: "some-id")`
document.addEventListener("turbo:load", () => {
  const anchor = new URLSearchParams(location.search).get("_anchor");
  if (anchor) {
    document.getElementById(anchor)?.scrollIntoView({ behavior: "smooth" });
    const url = new URL(location.href);
    url.searchParams.delete("_anchor");
    history.replaceState({}, "", url);
  }
});
